import React from "react";

const PaginationBar = ({ page, setPage, totalPages, totalCount }) => {
  if (totalCount === 0 || totalPages === 0) return null;

  const renderPageButtons = () => {
    const buttons = [];
    const maxVisiblePages = 5;

    if (totalPages <= maxVisiblePages) {
      for (let i = 1; i <= totalPages; i++) {
        buttons.push(
          <button
            key={i}
            className={`inventory-pagination-btn${page === i ? " active" : ""}`}
            onClick={() => setPage(i)}
          >
            {i}
          </button>
        );
      }
    } else {
      buttons.push(
        <button
          key={1}
          className={`inventory-pagination-btn${page === 1 ? " active" : ""}`}
          onClick={() => setPage(1)}
        >
          1
        </button>
      );

      if (page > 3) {
        buttons.push(
          <span key="start-ellipsis" className="pagination-ellipsis">
            ...
          </span>
        );
      }

      const startPage = Math.max(2, page - 1);
      const endPage = Math.min(totalPages - 1, page + 1);

      for (let i = startPage; i <= endPage; i++) {
        if (i !== 1 && i !== totalPages) {
          buttons.push(
            <button
              key={i}
              className={`inventory-pagination-btn${
                page === i ? " active" : ""
              }`}
              onClick={() => setPage(i)}
            >
              {i}
            </button>
          );
        }
      }

      if (page < totalPages - 2) {
        buttons.push(
          <span key="end-ellipsis" className="pagination-ellipsis">
            ...
          </span>
        );
      }

      if (totalPages > 1) {
        buttons.push(
          <button
            key={totalPages}
            className={`inventory-pagination-btn${
              page === totalPages ? " active" : ""
            }`}
            onClick={() => setPage(totalPages)}
          >
            {totalPages}
          </button>
        );
      }
    }

    return buttons;
  };

  return (
    <div className="inventory-pagination-bar">
      <div className="inventory-pagination-info">
        {/* <span>
          Showing {(page - 1) * pageSize + 1}-
          {Math.min(page * pageSize, totalCount)} of {totalCount}
        </span> */}
      </div>
      <div className="inventory-pagination-controls">
        <button
          className="inventory-pagination-btn"
          disabled={page === 1}
          onClick={() => setPage(page - 1)}
        >
          Prev
        </button>
        {renderPageButtons()}
        <button
          className="inventory-pagination-btn"
          disabled={page === totalPages}
          onClick={() => setPage(page + 1)}
        >
          Next
        </button>
      </div>
    </div>
  );
};

export default PaginationBar;
